import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Role } from '../../models/role.model';
import { RoleService } from '../../services/role.service';

@Injectable({ providedIn: 'root' })
export class RoleResolver implements Resolve<Role> {

    constructor(private roleService: RoleService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Role>
        | Promise<Role> | Role {

        return this.roleService.getRole(+route.params.roleId);
    }
}
